import axios, { Axios } from 'axios';

const axiosInstance = (paramsObject: any): Axios => {
    const { props } = paramsObject;
    const { builderPreview, builder, templatePreview, componentsPreview, nextJs } = props;
    const axiosInstance = axios.create();
    axiosInstance.defaults.baseURL = process.env.REACT_APP_USERS_API_SERVER_URL;
    axiosInstance.defaults.headers.get['Accept'] = 'application/json';
    axiosInstance.defaults.headers.post['Accept'] = 'application/json';
    axiosInstance.defaults.headers.common['x-request-origin'] = (builder || builderPreview || componentsPreview) ? "builder" : templatePreview ? "templatePreview" : "user_site";
    axiosInstance.defaults.withCredentials = true;
    if (nextJs) {
        axiosInstance.defaults.headers.common.Authorization = `Bearer ${props?.token}`;

    }
    if (templatePreview || builderPreview || builder || componentsPreview) {
        axiosInstance.defaults.headers.common.Authorization = `Bearer ${sessionStorage.getItem("token")}`;
    }
    if (!templatePreview && !builderPreview && !builder && !componentsPreview && !nextJs) {
        axiosInstance.defaults.headers.common.Authorization = `Bearer ${process.env.REACT_APP_ACCESS_TOKEN}`;
    }
    axiosInstance.interceptors.request.use(function (request) {

        return request;
    }, function () {
        alert("unable to load");
    });
    axiosInstance.interceptors.response.use(function (response) {

        return response;
    }, async function (error) {


        if (error.response) {
            if (paramsObject.data.authenticated) {
                if (error.response.status === 401) {
                    await axios.get(`${process.env.REACT_APP_USERS_API_SERVER_URL}/v1/ecommerce/logout`, {
                        withCredentials: true,
                        headers: {
                            "x-request-origin": (builder || builderPreview || componentsPreview) ? "builder" : templatePreview ? "templatePreview" : "user_site",
                            ...(
                                (!templatePreview && !builderPreview && !builder && !componentsPreview && !nextJs) &&
                                {
                                    Authorization: `Bearer ${process.env.REACT_APP_ACCESS_TOKEN}`
                                }
                            ),
                            ...(
                                (templatePreview || builder || builderPreview || componentsPreview) && {
                                    Authorization: `Bearer ${sessionStorage.getItem("token")}`
                                }
                            ),
                            ...(
                                nextJs && {
                                    Authorization: `Bearer ${props.token}`
                                }
                            )
                        }
                    });
                    window.location.href = '/login';
                    alert('Session expired, please login again');
                    throw "Session expired, please login again";
                }
            }
        }
        throw error;
    });
    return axiosInstance;
}

export default axiosInstance;